import { CoverageNeed } from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { InsuranceCoverage } from "Store/advice/interfaces";
import { isDefined } from "Utils/functions";
import React from "react";

interface Props {
  need: CoverageNeed;
  adviceTexts: any;
  lang: string;
}

export const AkaDisabilityAdviceText = ({
  need,
  adviceTexts,
  lang,
}: Props): React.ReactElement | null => {
  const recommendedCoverage = need.recommendedCoverage;
  if (!isDefined(recommendedCoverage)) {
    return null;
  }

  const { desc } = adviceTexts;
  const weAdvice = "Vi anbefaler en utbetaling som samlet tilsvarer ";
  let percent = "";
  if (recommendedCoverage === InsuranceCoverage.TOP) {
    percent = desc.part2.top[lang];
  } else if (recommendedCoverage === InsuranceCoverage.PLUS) {
    percent = desc.part2.plus[lang];
  } else if (recommendedCoverage === InsuranceCoverage.BASIC) {
    percent = desc.part2.basic[lang];
  }

  const ofIncome =
    " av dagens lønn hvis du blir helt ufør*. Anbefalingen er basert på at du ";

  let becauseOfYourEconomicalSituation = "";
  if (recommendedCoverage === InsuranceCoverage.BASIC) {
    becauseOfYourEconomicalSituation =
      "kan tåle en betydelig nedgang i økonomien.";
  } else if (recommendedCoverage === InsuranceCoverage.PLUS) {
    becauseOfYourEconomicalSituation = "kan tåle litt nedgang i økonomien.";
  } else if (recommendedCoverage === InsuranceCoverage.TOP) {
    becauseOfYourEconomicalSituation = "må ha økonomi som i dag.";
  }

  let inflation = "";
  if (recommendedCoverage === InsuranceCoverage.PLUS) {
    inflation =
      "*For å hensynta fremtidig inflasjon og tapt kjøpekraft er en ekstra årslønn bakt inn i anbefalingen.";
  } else if (recommendedCoverage === InsuranceCoverage.TOP) {
    inflation =
      "*For å hensynta fremtidig inflasjon og tapt kjøpekraft er to ekstra årslønner bakt inn i anbefalingen.";
  }

  return (
    <>
      <Description fw={400} size="14px" className="AdviceTextsReason">
        {`${weAdvice}${percent}${ofIncome}${becauseOfYourEconomicalSituation}`}
      </Description>
      <Description fw={400} size="14px" className="AdviceTextsReason">
        {inflation}
      </Description>
    </>
  );
};
